import './clientportal-core.css';
import { b4 as setTag, b5 as captureMessage, b6 as captureException } from "./BrandedApp-BnlUHEvF.js";
import { b3, b2, a1, b7, be, bf, bg, b8, b9, x, i, bh, bi, b, bj, ba, bb, bc, bd } from "./BrandedApp-BnlUHEvF.js";
const Sentry = {
  captureException,
  captureMessage,
  setTag
};
export {
  b3 as ClientPortalApps,
  Sentry,
  b2 as SwipeDirective,
  a1 as addChatWidgetPositioningScript,
  b7 as getFirebaseAppInstance,
  be as getSessionContactId,
  bf as getSessionCookieData,
  bg as getSessionCookies,
  b8 as handleServiceWorkerMessage,
  b9 as initializeApp,
  x as isAuthV2Enabled,
  i as isGokollab,
  bh as isGokollabMobile,
  bi as isMobileOs,
  b as isPwa,
  bj as isWebKit,
  ba as registerPushToken,
  bb as requestNotificationPermission,
  bc as sendNotificationToken,
  bd as validatePwaAuth
};
